import React from 'react'
import styled from 'styled-components'
import { graphql, compose } from 'react-apollo'
import Button from '../../common/Button'
import UpdateDocumentStatus from './../queries/UpdateDocumentStatus'
import UpdateDocumentComment from './../queries/UpdateDocumentComment'
import DocumentsQuery from './../queries/DocumentsQuery'
import LoadingButton from '../../common/LoadingButton'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'


const Container = styled(FadeInUpWrapper)`
  border: #b4b5b6 solid 1px;
  border-radius: 5px;
  padding: 30px;
  width: 420px;
  text-align: center;
  color: #666;
  background: white;
`
const Text = styled.h3`
  font-weight: 500;
  margin-bottom: 10px;
`
const TextArea = styled.textarea`
  resize: vertical;
  width: 100%;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`
const Apply = styled(LoadingButton)`
  margin-left: 3px;
`
const Cancel = Button.extend`
  background: #b4b5b6;
  margin-right: 3px;
`
class RejectedModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      comment: props.document.comment,
      isLoading: false
    }
  }
  getComment = reference => {
    let { comment } = this.state
    if (!reference) {
      return comment
    }
    const { date } = reference
    const key = this.props.getKeyRef(date)
    return JSON.parse(comment).find(({ dateRef }) => dateRef === key).comment
  }
  generateHash = referenceFiles => {
    const arrComments = []
    referenceFiles.forEach(({ date }) => {
      const key = this.props.getKeyRef(date)
      const hash = { dateRef: key, comment: null}
      arrComments.push(hash)
    })
    return JSON.stringify(arrComments)
  }
  onChange = ({ target }) => {
    let { value: targetComment } = target
    let comment = targetComment
    const { lastRejectedRef: reference, getKeyRef } = this.props
    if (reference) {
      const { comment: oldComment } = this.state
      const newComments = []
      const { date } = reference
      const key = getKeyRef(date)
      JSON.parse(oldComment).forEach(refDate => {
        const { dateRef } = refDate
        if (dateRef === key) {
          refDate.comment = targetComment
        }
        newComments.push(refDate)
      })
      comment = JSON.stringify(newComments)
    }
    this.setState({ comment })
  }
  componentWillMount() {
    const { document: doc } = this.props
    let { comment } = this.state
    let  { referenceFiles } = doc
    referenceFiles = JSON.parse(referenceFiles)
    if (referenceFiles.length > 0) {
      comment = !comment ? this.generateHash(referenceFiles) : comment
    }
    this.setState({ comment })
  }
  onSave = async () => {
    const {
      updateDocumentStatus,
      updateDocumentComment,
      toggleModal,
      toggleChangingStatus,
      changeStatus,
      updateDocumentData,
      document: doc,
      updateNotes
    } = this.props
    const { rid: documentId } = doc
    const { comment } = this.state
    try {
      await toggleChangingStatus()
      await this.setState({ isLoading: true })
      await updateDocumentComment({
        variables: {
          input: {
            documentId,
            comment
          }
        },
        update: (store, { data: { updateDocumentComment: { document } } }) => {
          updateDocumentData(document, store)
        }
      })
      await updateDocumentStatus({
        variables: {
          input: {
            documentId,
            status: 'rejected'
          }
        },
        update: (store, { data: { updateDocumentStatus: { document } } }) => {
          updateDocumentData(document, store)
        }
      })
      changeStatus('rejected')
      toggleChangingStatus()
      toggleModal()
    } catch (err) {
      console.log(err)
    }
  }
  render() {
    const { toggleModal, document: doc, lastRejectedRef: reference } = this.props
    const { adminOnly } = doc
    const { isLoading } = this.state
    const comment = this.getComment(reference)
    return (
      <Container id="reject_document_modal">
        <Text>
          Please provide a comment for rejection. { !adminOnly ? 'This comment will be shared with the Borrower.' : ''}
        </Text>
        <TextArea
          onChange={this.onChange}
          defaultValue={comment}
          maxLength="255"
          id="rejection_comment"
        />
        <ButtonContainer>
          <Cancel id="cancel_reject" onClick={toggleModal}>
            Cancel
          </Cancel>
          <Apply id="reject_document" onClick={this.onSave} loading={isLoading}>
            Apply
          </Apply>
        </ButtonContainer>
      </Container>
    )
  }
}
export default compose(
  graphql(UpdateDocumentStatus, {
    name: 'updateDocumentStatus'
  }),
  graphql(UpdateDocumentComment, {
    name: 'updateDocumentComment'
  })
)(RejectedModal)
